import React, { useEffect, useState, useCallback } from 'react'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { getMPDataWithParams } from 'src/mentor/services'
import { getSPDataWithParams } from 'src/supportPortal/services/services'

export default function usePrescriptionDataForTemplate({
  templateData,
  useEmptyBox = false,
  isSupportPortal = false,
  practitionerId,
}) {
  const [foundPrescriptionData, setFoundPrescriptionData] = useState(null)
  const [loading, setLoading] = useState(false)

  const fetchDummyData = useCallback(async () => {
    setLoading(true)
    try {
      let response
      if (isSupportPortal && practitionerId) {
        const params = {
          'practitioner-id': practitionerId,
          clinicId: templateData?.clinicId,
        }
        if (templateData?.id) params.templatePrescriptionId = templateData.id
        response = await getSPDataWithParams(
          '/api/secure/cc/support/practitioner/prescription/dummy',
          params,
        )
      } else {
        const params = {
          clinicId: templateData?.clinicId,
          empty: useEmptyBox,
        }
        response = await getMPDataWithParams('/api/secure/doctor/prescription/dummy', params)
      }
      if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
        const responseData = getDataMapFromCommonResponse(response)
        setFoundPrescriptionData(responseData?.metaPrescription)
      }
    } finally {
      setLoading(false)
    }
  }, [
    templateData?.clinicId,
    templateData?.id,
    useEmptyBox,
    isSupportPortal,
    practitionerId,
  ])

  useEffect(() => {
    const shouldFetch = isSupportPortal
      ? templateData?.clinicId && practitionerId
      : templateData?.clinicId && templateData?.id
    if (shouldFetch) {
      setFoundPrescriptionData(null)
      fetchDummyData()
    }
  }, [
    templateData?.clinicId,
    templateData?.id,
    useEmptyBox,
    isSupportPortal,
    practitionerId,
    fetchDummyData,
  ])

  const finalData = {
    ...templateData,
    prescriptionData: foundPrescriptionData?.prescriptionData,
    patientPrefill: foundPrescriptionData?.patientPrefill,
  }
  return {
    loadingPrescriptionData: loading,
    currentTemplateWithDummyData: finalData,
  }
}
